module.exports = __webpack_public_path__ + "img/lafayette_logo.593e0e4d.png";